module.exports = __webpack_public_path__ + "static/media/sash.376a3689.png";